import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const Home2Page = lazy(() => import('../pages/home-2/page'));
const ServicosPage = lazy(() => import('../pages/servicos/page'));
const SobrePage = lazy(() => import('../pages/sobre/page'));
const ContatoPage = lazy(() => import('../pages/contato/page'));

const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogPostPage = lazy(() => import('../pages/blog/post'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Service Pages
const AberturaPortasPage = lazy(() => import('../pages/abertura-portas/page'));
const MudancaFechadurasPage = lazy(() => import('../pages/mudanca-fechaduras/page'));
const ReparacaoFechadurasPage = lazy(() => import('../pages/reparacao-fechaduras/page'));
const InstalacaoMolaPage = lazy(() => import('../pages/instalacao-mola/page'));
const TrincoEletricosPage = lazy(() => import('../pages/trinco-eletricos/page'));
const CilindrosPortaBlindadaPage = lazy(() => import('../pages/cilindros-porta-blindada/page'));

// Policy Pages
const PrivacyPolicyPage = lazy(() => import('../pages/politica-privacidade/page'));
const CookiePolicyPage = lazy(() => import('../pages/politica-cookies/page'));

const routes: RouteObject[] = [
  { path: "/emergencia", element: <Home2Page campaign /> },
  {
    path: '/',
    element: <Home2Page />,
  },
  {
    path: '/home-old',
    element: <HomePage />,
  },
  {
    path: '/home-2',
    element: <Home2Page />,
  },
  {
    path: '/servicos',
    element: <ServicosPage />,
  },
  {
    path: '/sobre',
    element: <SobrePage />,
  },
  {
    path: '/contato',
    element: <ContatoPage />,
  },
  {
    path: '/abertura-portas',
    element: <AberturaPortasPage />,
  },
  {
    path: '/mudanca-fechaduras',
    element: <MudancaFechadurasPage />,
  },
  {
    path: '/reparacao-fechaduras',
    element: <ReparacaoFechadurasPage />,
  },
  {
    path: '/instalacao-mola',
    element: <InstalacaoMolaPage />,
  },
  {
    path: '/trinco-eletricos',
    element: <TrincoEletricosPage />,
  },
  {
    path: '/cilindros-porta-blindada',
    element: <CilindrosPortaBlindadaPage />,
  },
  {
    path: '/politica-privacidade',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/politica-cookies',
    element: <CookiePolicyPage />,
  },

  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPostPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
